import Button from 'components/Form/Button';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { GET } from 'services/api';
import { Icon, StatusContent, Title } from 'ui/styled';
import { normalizeResponse } from 'utils';
import { parseCurrency } from 'utils/parsers';
import { formatadores, normalizeName } from 'utils/validators';

export default function PreproposalRecusadas() {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const { user, filterExpression } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const [registers, setRegisters] = useState([]);
  const [tick, setTick] = useState(0);
  const opcao = 'recusado';
  const MAX_EXIBITION = 200;

  // Atualiza a cada 2 minutos
  useEffect(() => {
    const interval = setInterval(() => setTick((prev) => prev + 1), 120000);
    return () => clearInterval(interval);
  }, []);

  const init = useCallback(async () => {
    setLoading(true);
    try {
      const populate = 'distribuidor,integrador,banco,uf,bancos';
      const url = `/pre-proposals?populate=${populate}&filters[status][$eq]=reprovado&pagination[pageSize]=${MAX_EXIBITION}&sort[0]=createdAt:desc`;
      const result = await GET(url, true);
      const data = normalizeResponse(result);
      if (!data.length) {
        setRegisters([]);
        setLoading(false);
        return;
      }
      const sorted = data.sort((a, b) => (b.id || 0) - (a.id || 0));
      const next = sorted.map((item) => ({
        ...item,
        accepted: (item.bancos || []).find((f) => f.aceito),
      }));
      setRegisters(next);
    } catch (err) {
      console.error('Erro ao carregar pré-propostas:', err);
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }, []);
  const columns = useMemo(() => {
    const baseColumns = [
      { title: 'Id', sortable: true, ref: 'id' },
      {
        title: 'Data',
        sortable: true,
        ref: 'date',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row.date),
      },
      // Inserir coluna "Distribuidora" condicionalmente
      ...(user?.administrador ||
      (user?.distribuidor && user?.distribuidores?.length > 0)
        ? [
            {
              title: 'Distribuidora',
              sortable: true,
              ref: 'distributor',
            },
          ]
        : []),
      { title: 'Cliente', sortable: true, ref: 'customer' },
      { title: 'Valor', ref: 'value', renderCell: ({ row }) => row?.value },
      { title: 'Integrador', sortable: true, ref: 'nome_integrador' },
      {
        title: 'TAG',
        renderCell: () => {
          return <StatusContent color="red">Recusada</StatusContent>;
        },
      },
      // Inserir coluna "Espelho da Proposta" condicionalmente
      ...(user?.administrador
        ? [
            {
              title: 'Espelho da Proposta',
              ref: 'espelho',
              renderCell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={() => navigate(`financingproposal/${row?.id}`)}
                    color={'blue'}
                    nospace
                    mbutton
                    small
                  >
                    Visualizar
                  </Button>
                </div>
              ),
            },
          ]
        : []),
      {
        title: '',
        renderCell: ({ row }) => (
          <Icon
            icon="arrow-right"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              navigate(`financingtablepreanalise/${row?.id}/${opcao}`)
            }
          />
        ),
      },
    ];
    return baseColumns;
  }, [user, navigate]);
  const rows = useMemo(() => {
    return (registers || []).map((a) => ({
      id: a?.id,
      date: a?.createdAt,
      formatedDate: formatadores.TIMESTAMP_TO_BR(a?.createdAt),
      distributor: normalizeName(a?.distribuidor?.trade_name) || '-',
      customer: normalizeName(a?.nome_completo) || '-',
      value: parseCurrency(a?.valor_financiamento),
      nome_integrador: a?.nome_integrador || '-',
      cnpj_integrador: a?.cnpj_integrador,
      cnpj_integrador_clean: a?.cnpj_integrador.replace(/\D/g, ''),
      cpf_cnpj: a?.cpf || a?.cnpj,
      cpf_cnpj_clean: a?.cpf
        ? a?.cpf.replace(/\D/g, '')
        : a?.cnpj.replace(/\D/g, ''),
    }));
  }, [registers]);

  useEffect(() => init(), [init, tick]);

  return (
    <ContainerAuthenticated>
      <Title>Pré-Financiamento</Title>
      <TableWrapper title="Recusadas" search>
        <BasicTable
          loading={loading}
          columns={columns}
          rows={rows?.filter(filterExpression)}
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
